import Table from '@/components/table/components/Table.tsx';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';
import bookingsApi from '@/features/dashboard/bookings/api/bookingsApi.ts';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { useNavigate } from '@tanstack/react-router';
import { bookingsRoute } from '@/features/dashboard/bookings/routes/bookingsRoute.ts';

const BookingsTable = () => {
  const navigate = useNavigate();
  const search = bookingsRoute.useSearch();

  const rowContextMenuItems: RowContextMenuItemParams<RowWithId>[] = [
    {
      label: 'Szczegóły',
      action: (row) =>
        navigate({
          to: '/app/bookings/$bookingId/booking',
          params: { bookingId: row.id },
        }),
    },
  ];

  return (
    <Table
      listSearch={search}
      queryKey={bookingsApiQueryKeys.all()}
      fetchData={bookingsApi.getAll}
      fetchTableDef={bookingsApi.getTableDefinition}
      rowContextMenuItems={rowContextMenuItems}
      title="Rezerwacje"
    />
  );
};

export default BookingsTable;
